import React, { useState, useEffect } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../redux/actions";
import { Collapse } from "reactstrap";
import "./sidebar-admin.scss";

const adminMenuItems = [
  {
    id: "dashboard",
    icon: "iconsminds-home-1",
    label: "Dashboard",
    to: "/root/dashboard",
  },
  {
    id: "message",
    icon: "iconsminds-mail",
    label: "Message Manager",
    to: "/root/message/dashboards",
  },
  {
    id: "upgrade",
    icon: "iconsminds-upgrade",
    label: "Upgrade Manager",
    to: "/root/upgrade/dashboards",
  },
  {
    id: "product-templates",
    icon: "simple-icon-list",
    label: "Duyệt đóng góp mẫu",
    to: "/root/product-templates",
  },
  {
    id: "affiliates",
    icon: "iconsminds-handshake",
    label: "Affiliate Manager",
    to: "/root/affiliates",
    subs: [
      {
        label: "Affiliate Dashboard",
        to: "/root/affiliates/dashboard",
        icon: "simple-icon-graph",
      },
      {
        label: "Affiliate List",
        to: "/root/affiliates/list",
        icon: "simple-icon-people",
      },
      {
        label: "Campaigns",
        to: "/root/affiliates/campaigns",
        icon: "simple-icon-link",
      },
      {
        label: "Payout Requests",
        to: "/root/affiliates/payouts",
        icon: "iconsminds-money-bag",
      },
      {
        label: "Commission Config",
        to: "/root/affiliates/commission",
        icon: "simple-icon-equalizer",
      },
      {
        label: "Marketing Kit",
        to: "/root/affiliates/marketing-kit",
        icon: "simple-icon-picture",
      },
      {
        label: "Affiliate Reports",
        to: "/root/affiliates/reports",
        icon: "simple-icon-chart",
      },
      {
        label: "Fraud Control",
        to: "/root/affiliates/fraud",
        icon: "simple-icon-shield",
      },
    ],
  },
];

const SidebarAdmin = ({ history, location }) => {
  const dispatch = useDispatch();
  // Initialize open state based on current path
  const [openMenu, setOpenMenu] = useState(
    location.pathname.includes("affiliates") ? "affiliates" : "",
  );

  useEffect(() => {
    document.body.classList.add("admin-layout");
    return () => {
      document.body.classList.remove("admin-layout");
    };
  }, []);

  const onLogoutClick = (e) => {
    e.preventDefault();
    dispatch(logoutUser(history));
  };

  const toggleMenu = (e, id) => {
    e.preventDefault();
    if (openMenu === id) {
      setOpenMenu("");
    } else {
      setOpenMenu(id);
    }
  };

  return (
    <div className="sidebar-admin">
      <div className="sidebar-admin-header">
        <img
          src="/assets/img/logo-horizontal.svg"
          alt="VMASS Admin"
          style={{ height: "36px" }}
        />
        <span className="brand-suffix">Admin</span>
      </div>
      <nav className="sidebar-admin-nav">
        <ul>
          {adminMenuItems.map((item) => {
            if (item.subs) {
              const isActive = location.pathname.includes(item.to);
              const isOpen = openMenu === item.id;

              return (
                <li key={item.id} className={isActive ? "active-parent" : ""}>
                  <a
                    href={item.to}
                    onClick={(e) => toggleMenu(e, item.id)}
                    className={`nav-link-parent ${isOpen ? "open" : ""}`}
                  >
                    <i className={item.icon} />
                    <span>{item.label}</span>
                    <i
                      className={`simple-icon-arrow-down arrow-icon ${
                        isOpen ? "rotate" : ""
                      }`}
                    />
                  </a>
                  <Collapse isOpen={isOpen}>
                    <ul className="submenu">
                      {item.subs.map((sub, index) => (
                        <li key={index}>
                          <NavLink
                            to={sub.to}
                            activeClassName="active"
                            className="nav-link-sub"
                          >
                            <i className={sub.icon} />
                            <span>{sub.label}</span>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </Collapse>
                </li>
              );
            }

            return (
              <li key={item.id}>
                <NavLink to={item.to} activeClassName="active">
                  <i className={item.icon} />
                  <span>{item.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="sidebar-admin-footer">
        <a href="/logout" onClick={onLogoutClick} className="logout-btn">
          <i className="simple-icon-logout" />
          <span>Đăng xuất</span>
        </a>
      </div>
    </div>
  );
};

export default withRouter(SidebarAdmin);
